import SECRETS from '../ssm-secrets.json';

const { apiUrl, stage, appVersion } = SECRETS;

export const CORS_PROXY = `${apiUrl}/proxy/`;
export const PODCAST_SEARCH_URL = `${apiUrl}/podcasts-search`;
export const STAGE = stage;
export const APP_VERSION = appVersion;
